import React from 'react'
import { Modal } from 'is24-corecss'
import styles from './VideoPreviewModal.module.css'
import { StreamingVideoUrl } from '../../../../../../../../../@types/types'

type VideoPreviewModalProps = {
  visible: boolean
  onClick: () => void
  videoInfoSourceUrls: StreamingVideoUrl[]
}

const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({ visible, onClick, videoInfoSourceUrls }) => {
  return (
    <Modal.Root isOpen={visible} onClose={onClick}>
      <Modal.Backdrop className='absolute-reference'>
        <Modal.Container>
          <Modal.Header>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <video className={`${styles.videoPreview} border-radius-rounded`} controls data-testid='video-preview'>
              {videoInfoSourceUrls.map((src) => (
                <source key={src.url} src={src.url} />
              ))}
            </video>
          </Modal.Body>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal.Root>
  )
}
export default VideoPreviewModal
